<div class="container-fluid mt-3">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2>Counsellor MOM Sessions</h2>
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      Add New Session
    </button>
  </div>


  <!-- Search Filter -->
<!--  <mat-form-field appearance="outline" class="w-100 mb-3">-->
<!--    <mat-label>Search</mat-label>-->
<!--    <input matInput (keyup)="applyFilter($event)" placeholder="Search sessions...">-->
<!--    <mat-icon matSuffix>search</mat-icon>-->
<!--  </mat-form-field>-->


  <div class="row align-items-center mb-3">
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Filter by Date</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="dateFilter" placeholder="Select date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-2 mb-3 d-flex gap-2">
      <button mat-mini-fab color="accent" (click)="onSearch()" matTooltip="Search">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-mini-fab color="accent" (click)="onClear()" matTooltip="Clear Filters">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>


  <!-- Table -->
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let element">{{ element?.date.toDate()| date:'dd/MM/yyyy' }}</td>
      </ng-container>

      <!-- Topic Column -->
<!--      <ng-container matColumnDef="topic">-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Topic</th>-->
<!--        <td mat-cell *matCellDef="let element">{{ element.topic }}</td>-->
<!--      </ng-container>-->

      <!-- Participants Column -->
      <ng-container matColumnDef="participants">
        <th mat-header-cell *matHeaderCellDef>Participants</th>
        <td mat-cell *matCellDef="let element">
          <span class="participants-text" [title]="getParticipantNames(element.participants)">
            {{ getParticipantNames(element.participants) | slice:0:400 }}
            {{ getParticipantNames(element.participants).length > 400 ? '...' : '' }}
          </span>
        </td>
      </ng-container>

            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Remark</th>
              <td mat-cell *matCellDef="let element">{{ element.remarks }}</td>
            </ng-container>

      <!-- Session Count Column -->
<!--      <ng-container matColumnDef="sessionCount">-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Items</th>-->
<!--        <td mat-cell *matCellDef="let element">-->
<!--          <span class="badge badge-info">{{ getSessionCount(element) }} items</span>-->
<!--        </td>-->
<!--      </ng-container>-->

      <!-- Actions Column -->
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <!-- Show edit button only if conditions are met -->
          <!-- View -->
          <button
            permission="Counselling MOM"
            [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]"
            mat-icon-button
            color="accent"
            (click)="openViewDialog(element)"
            matTooltip="View">
            <mat-icon>visibility</mat-icon>
          </button>
          <button
            permission="Counselling MOM"
            [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]"
            *ngIf="canEditSession(element)"
            mat-icon-button
            color="primary"
            (click)="openEditDialog(element)"
            matTooltip="Edit">
            <mat-icon>edit</mat-icon>
          </button>

          <button
            permission="Counselling MOM"
            [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]"
            mat-icon-button
            color="warn"
            (click)="deleteSession(element)"
            matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- No Data Row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-5" [attr.colspan]="displayedColumns.length">
          No sessions found
        </td>
      </tr>
    </table>
    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons>
    </mat-paginator>
</div>
</div>
<ng-template #viewDialog>
  <h2 mat-dialog-title>Counsellor MOM – Session Details</h2>

  <mat-dialog-content class="mt-2">

    <!-- BASIC DETAILS -->
    <table class="table table-bordered table-sm w-100 mb-3">
      <tbody>
      <tr>
        <th style="width: 30%">Date</th>
        <td>{{ getDate(selectedSession?.date) | date:'dd/MM/yyyy' }}</td>
      </tr>

      <tr>
        <th>Status</th>
        <td>{{ selectedSession?.status || '-' }}</td>
      </tr>

      <tr>
        <th>Topic</th>
        <td>{{ selectedSession?.topic || '-' }}</td>
      </tr>

      <tr>
        <th>Participants</th>
        <td>
          <ul class="mb-0 ps-3">
            <li *ngFor="let p of selectedSession?.participants">
              {{ p }}
            </li>
          </ul>
        </td>
      </tr>
      </tbody>
    </table>

    <!-- SESSION ITEMS -->
    <h6 class="fw-bold mb-2">Session Items</h6>

    <table
      class="table table-bordered table-sm w-100"
      *ngIf="selectedSession?.sessions?.length; else noSessions">
      <thead class="table-light">
      <tr>
        <th style="width: 20%">Topic</th>
        <th style="width: 55%">Discussion Summary</th>
        <th style="width: 25%">Person In Charge</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let s of selectedSession?.sessions">
        <td>{{ s.topic || '-' }}</td>
        <td>{{ s.discussionSummary || '-' }}</td>
        <td>{{ s.personInCharge || '-' }}</td>
      </tr>
      </tbody>
    </table>

    <ng-template #noSessions>
      <p class="text-muted fst-italic">No session items added</p>
    </ng-template>

    <!-- AUDIT DETAILS -->
    <table class="table table-bordered table-sm w-100 mt-3">
      <tbody>
      <tr>
        <th style="width: 30%">Created By</th>
        <td>{{ selectedSession?.createdBy || '-' }}</td>
      </tr>

      <tr>
        <th>Created At</th>
        <td>{{ getDate(selectedSession?.createdAt) | date:'dd/MM/yyyy, hh:mm a' }}</td>
      </tr>

      <tr>
        <th>Updated By</th>
        <td>{{ selectedSession?.updatedBy || '-' }}</td>
      </tr>

      <tr>
        <th>Updated At</th>
        <td>{{ getDate(selectedSession?.updatedAt) | date:'dd/MM/yyyy, hh:mm a' }}</td>
      </tr>
      </tbody>
    </table>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" (click)="closeView()">
      Close
    </button>
  </mat-dialog-actions>
</ng-template>




<!-- Loading Spinner -->
<div *ngIf="isLoading" class="text-center py-5">
  <mat-spinner></mat-spinner>
</div>
